import styled from '@emotion/styled';

export const Index = styled.div<{ index: string }>`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  line-height: 14px;
  font-size: 10px;
  text-align: center;
  border: solid 1px;
  border-radius: 2px;
  color: ${({ index }) => (index === '0' ? '#E02020' : index === '1' ? '#FA6400' : '#F7B500')};
  border-color: ${({ index }) =>
    index === '0' ? '#E02020' : index === '1' ? '#FA6400' : '#F7B500'};
  background: ${({ index }) =>
    index === '0'
      ? 'rgba(224, 32, 32, .2)'
      : index === '1'
      ? 'rgba(250, 100, 0, .2)'
      : 'rgba(247, 181, 0, .2)'};
`;

export const Index2 = styled.div<{ index: string }>`
  position: relative;
  > span {
    position: relative;
    display: inline-block;
    width: 14px;
    height: 14px;
    line-height: 14px;
    margin-right: 4px;
    margin-bottom: 2px;
    text-align: center;
    border-radius: 7px;
    color: #fff;
    background: ${({ index }) =>
      index === '0' ? '#FFD04E' : index === '1' ? '#D8D8E1' : '#D4996C'};
    z-index: 1;
  }
  &::before {
    display: inline-block;
    content: '';
    position: absolute;
    left: 1px;
    bottom: 1px;
    width: 12px;
    height: 6px;
    background: #e02020;
    z-index: 0;
  }
  &::after {
    display: inline-block;
    content: '';
    position: absolute;
    left: 2px;
    bottom: -6px;
    width: 10px;
    height: 10px;
    background: #fff;
    transform: rotateZ(45deg);
    z-index: 0;
  }
`;
